import * as React from 'react';

function SvgExpandIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 14" {...props}>
    <path stroke="#007BFF" d="m9.485 8.243-4.242 4.242L1 8.243" />
    <path stroke="#007BFF" d="M9.485 4.243 5.243 8.485 1 4.243" />
  </svg>)
}
export default SvgExpandIcon;
